import { render, staticRenderFns } from "./DenyTest.vue?vue&type=template&id=0b35f542&scoped=true&"
import script from "./DenyTest.vue?vue&type=script&lang=js&"
export * from "./DenyTest.vue?vue&type=script&lang=js&"
import style0 from "./DenyTest.vue?vue&type=style&index=0&id=0b35f542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b35f542",
  null
  
)

export default component.exports